import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { InsertSpacePipe } from '@out-web/core';

@Component({
  selector: 'out-listing-type',
  standalone: true,
  imports: [CommonModule, InsertSpacePipe],
  templateUrl: './listing-type.component.html',
  styleUrl: './listing-type.component.scss',
})
export class ListingTypeComponent {
  @Input() type: string | undefined;

  get typeClass(): string {
    const formattedType = this.type?.toLowerCase().replace(/\s+/g, '-');
    return `listing-type__label--${formattedType}`;
  }
}
